import React, { Component } from 'react';
import { observer } from 'mobx-react';
import loading from '../../static/images/loading2.gif';

import './index.css'
@observer
class Load extends Component {
    render() {
        return (
            <div className='homeLoading'>
                <div>
                    <img src={loading} alt="" />
                    <p>请等待...</p>
                </div>
            </div >
        )
    }
}
export default Load